(function () {

  const VAT_RATES = {
    AT: 0.20,
    BE: 0.21,
    BG: 0.20,
    HR: 0.25,
    CY: 0.19,
    CZ: 0.21,
    DK: 0.25,
    EE: 0.24,
    FI: 0.255,
    FR: 0.20,
    DE: 0.19,
    GR: 0.24,
    HU: 0.27,
    IE: 0.23,
    IT: 0.22,
    LV: 0.21,
    LT: 0.21,
    LU: 0.17,
    MT: 0.18,
    NL: 0.21,
    PL: 0.23,
    PT: 0.23,
    RO: 0.21,
    SK: 0.23,
    SI: 0.22,
    ES: 0.21,
    SE: 0.25,
    XI: 0.20,
    GB: 0.20,
  };

  const COUNTRY_NAME_TO_CODE = {
    'AUSTRIA': 'AT', 'BELGIUM': 'BE', 'BULGARIA': 'BG', 'CROATIA': 'HR',
    'CYPRUS': 'CY', 'CZECH REPUBLIC': 'CZ', 'DENMARK': 'DK', 'ESTONIA': 'EE',
    'FINLAND': 'FI', 'FRANCE': 'FR', 'GERMANY': 'DE', 'GREECE': 'GR',
    'HUNGARY': 'HU', 'IRELAND': 'IE', 'ITALY': 'IT', 'LATVIA': 'LV',
    'LITHUANIA': 'LT', 'LUXEMBOURG': 'LU', 'MALTA': 'MT', 'NETHERLANDS': 'NL',
    'POLAND': 'PL', 'PORTUGAL': 'PT', 'ROMANIA': 'RO', 'SLOVAKIA': 'SK',
    'SLOVENIA': 'SI', 'SPAIN': 'ES', 'SWEDEN': 'SE', 'UNITED KINGDOM': 'GB',
    'NORTHERN IRELAND': 'XI', 'UNITED STATES': 'US', 'CANADA': 'CA',
    'AUSTRALIA': 'AU', 'NEW ZEALAND': 'NZ', 'SINGAPORE': 'SG', 'JAPAN': 'JP',
    'SWITZERLAND': 'CH',
  };

  const NO_VAT_COUNTRIES = ['US', 'CA', 'AU', 'NZ', 'SG', 'JP', 'CH'];

  let resolvedCountry = null;
  let debounceTimer = null;
  let decimalSep = ',';
  let thousandsSep = '.';

  function detectSeparators() {
    const sample = document.querySelector('.price .amount');
    if (!sample) return;
    const text = sample.textContent.replace(/[^0-9.,]/g, '').trim();
    const lastDot = text.lastIndexOf('.');
    const lastComma = text.lastIndexOf(',');
    if (lastDot > lastComma) {
      decimalSep = '.';
      thousandsSep = ',';
    } else {
      decimalSep = ',';
      thousandsSep = '.';
    }
  }

  function formatMoney(cents, currencyCode) {
    const amount = cents / 100;
    const intPart = Math.floor(amount);
    const decPart = Math.round((amount - intPart) * 100).toString().padStart(2, '0');
    const intFormatted = intPart.toString().replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep);
    const number = intFormatted + decimalSep + decPart;

    const moneyFormat = window.themeMoneyFormat || window.Shopify?.money_format || '€{{amount}}';
    return moneyFormat
      .replace('{{amount_with_comma_separator}}', number)
      .replace('{{amount_no_decimals_with_comma_separator}}', intFormatted)
      .replace('{{amount_no_decimals}}', intFormatted)
      .replace('{{amount_with_currency}}', number + ' ' + currencyCode)
      .replace('{{amount}}', number);
  }

  function updateExclPrices(countryCode) {
    const country = (countryCode || '').toUpperCase();

    if (NO_VAT_COUNTRIES.includes(country)) {
      document.querySelectorAll('.price-tax-label').forEach(function (el) {
        el.style.display = 'none';
      });
      document.querySelectorAll('.price-excl-tax').forEach(function (el) {
        el.style.display = 'none';
      });
      return;
    }

    document.querySelectorAll('.price-excl-tax').forEach(function (el) {
      const priceInCents = parseInt(el.dataset.price, 10);
      const currency = el.dataset.currency || 'EUR';
      if (isNaN(priceInCents)) return;

      const amountEl = el.querySelector('.price-excl-tax__amount');
      if (amountEl) {
        amountEl.textContent = formatMoney(priceInCents, currency);
      }
    });
  }

  window.__testDualPrice = updateExclPrices;

  function debouncedUpdate() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      if (!resolvedCountry) return;

      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var containers = [
            document.querySelector('#Cart'),
            document.querySelector('#Cart-Drawer')
          ];

          containers.forEach(function (container) {
            if (!container) return;

            var totalExclCents = 0;
            container.querySelectorAll('.price-excl-tax--line-item[data-price]').forEach(function (el) {
              totalExclCents += parseInt(el.dataset.price, 10) || 0;
            });

            container.querySelectorAll('.cart-total-excl-tax').forEach(function (el) {
              el.dataset.price = totalExclCents;
              el.dataset.currency = cart.currency;
            });
          });

          detectSeparators();
          updateExclPrices(resolvedCountry);
        })
        .catch(function () {
          detectSeparators();
          updateExclPrices(resolvedCountry);
        });
    }, 150);
  }

  function setupObservers() {
    /* ── Cart page ── */
    const cartContainer = document.querySelector('#Cart');
    if (cartContainer) {
      new MutationObserver(function (mutations) {
        for (const mutation of mutations) {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            for (const node of mutation.addedNodes) {
              if (node.nodeType === 1 && !node.classList.contains('loading-overlay')) {
                debouncedUpdate();
                return;
              }
            }
          }
        }
      }).observe(cartContainer, { childList: true, subtree: true });
    }

    /* ── Cart drawer ── */
    const cartDrawer = document.querySelector('#Cart-Drawer');
    if (cartDrawer) {
      new MutationObserver(function (mutations) {
        for (const mutation of mutations) {
          if (mutation.type === 'childList') {
            for (const node of mutation.addedNodes) {
              if (node.nodeType === 1 && node.classList.contains('side-panel-inner')) {
                debouncedUpdate();
                return;
              }
            }
          }
        }
      }).observe(cartDrawer, { childList: true });
    }

    /* ── Variant change on product page ── */
    document.addEventListener('product:variant-change', function () {
      setTimeout(function () {
        if (!resolvedCountry) return;
        detectSeparators();
        updateExclPrices(resolvedCountry);
      }, 300);
    });

    /* ── Product detail MutationObserver fallback ── */
    const productDetail = document.querySelector('.thb-product-detail');
    if (productDetail) {
      new MutationObserver(function (mutations) {
        if (!resolvedCountry) return;
        for (const mutation of mutations) {
          for (const node of mutation.addedNodes) {
            if (node.nodeType === 1) {
              detectSeparators();
              updateExclPrices(resolvedCountry);
              return;
            }
          }
        }
      }).observe(productDetail, { childList: true, subtree: true });
    }

    /* ── Product quick view drawer ── */
    const productDrawerContent = document.querySelector('#Product-Drawer-Content');
    if (productDrawerContent) {
      let productDrawerDebounce = null;
      new MutationObserver(function () {
        if (!resolvedCountry) return;
        clearTimeout(productDrawerDebounce);
        productDrawerDebounce = setTimeout(function () {
          detectSeparators();
          updateExclPrices(resolvedCountry);
        }, 200);
      }).observe(productDrawerContent, { childList: true });
    }

    /* ── Search drawer — dynamic results panel only ── */
    /* childList only (no subtree) to avoid freeze on innerHTML swap */
    const searchResultsPanel = document.querySelector('#Search-Drawer .side-panel-content--has-tabs');
    if (searchResultsPanel) {
      let searchDebounce = null;
      new MutationObserver(function () {
        if (!resolvedCountry) return;
        clearTimeout(searchDebounce);
        searchDebounce = setTimeout(function () {
          detectSeparators();
          updateExclPrices(resolvedCountry);
        }, 200);
      }).observe(searchResultsPanel, { childList: true });
    }

    /* ── Search drawer — trending panel on open ── */
    document.addEventListener('SidePanel:open', function (e) {
      if (e.detail?.id !== 'Search-Drawer') return;
      if (!resolvedCountry) return;
      detectSeparators();
      updateExclPrices(resolvedCountry);
    });

    /* ── Search open event from PredictiveSearch ── */
    document.addEventListener('search:open', function () {
      if (!resolvedCountry) return;
      detectSeparators();
      updateExclPrices(resolvedCountry);
    });

    document.addEventListener('cart:updated', debouncedUpdate);
    document.addEventListener('cart:refresh', debouncedUpdate);
    document.addEventListener('CartDrawer:open', debouncedUpdate);
  }

  function init() {
    fetch('/browsing_context_suggestions.json')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        const rawCode = data?.detected_values?.country?.handle?.toUpperCase() || null;
        const rawName = data?.detected_values?.country_name?.toUpperCase() || null;
        resolvedCountry = rawCode || COUNTRY_NAME_TO_CODE[rawName] || 'LT';
        detectSeparators();
        debouncedUpdate();
      })
      .catch(function () {
        resolvedCountry = 'LT';
        detectSeparators();
        debouncedUpdate();
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setupObservers();
      init();
    });
  } else {
    setupObservers();
    init();
  }

})();